
export enum OrderState {
  Unconfirmed= 'Unconfirmed',
  Processing= 'Processing',
  Handled= 'Handled',
  Paid= 'Paid',
  Canceled= 'Canceled',
  NotPaid= 'NotPaid',

}